import type { TableColumn } from "react-data-table-component";
import type { Testimony } from "../../../../core/testimony/entities/Testimony";
import type { TranslationFunction } from "../../../../utils/utils";
import CachedImage from "../../../components/image/CachedImage";
import { badgeClasses } from "../../../constants/badgeClasses";

export const statusOptions = {
  draft: "testimony.status.draft",
  available: "testimony.status.available",
  unavailable: "testimony.status.unavailable",
};

export const classes = {
  draft: badgeClasses.primary,
  available: badgeClasses.success,
  unavailable: badgeClasses.error,
};

const testimonyTableConfig = (
  t: TranslationFunction
): TableColumn<Testimony>[] => [
  {
    name: "testimony.field.rank",
    selector: (row: Testimony) => row.rank ?? "",
    width: "60px",
    sortable: true,
  },
  {
    name: "testimony.field.image",
    width: "75px",
    cell: (row: Testimony) =>
      row.image ? (
        <CachedImage
          src={row.image}
          alt={row.title}
          className="w-10 h-10 object-cover rounded-lg"
        />
      ) : (
        <div></div>
      ),
  },
  {
    name: "testimony.field.title",
    selector: (row: Testimony) => row.title,
  },
  {
    name: "testimony.field.subtitle",
    selector: (row: Testimony) => row.subtitle,
  },
  {
    name: "testimony.field.description",
    selector: (row: Testimony) => row.description ?? "",
    width: "300px",
  },
  {
    name: "testimony.field.status",
    selector: (row: Testimony) =>
      t(row.status in statusOptions ? statusOptions[row.status] : ""),
    cell: (row: Testimony) => (
      <span className={classes[row.status]}>
        {t(row.status in statusOptions ? statusOptions[row.status] : "")}
      </span>
    ),
  },
];

export default testimonyTableConfig;
